// url
export const linkReg =
  // eslint-disable-next-line
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const linkRegex = /https?:\/\/[^\s]+/g;

// 2023-01-01
export const datePattern = /^\d{4}-\d{2}-\d{2}$/;
